export default "__VITE_ASSET__BQ6h64rJ__"